import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDevice } from "../layout/DeviceContext";

export default function Ethernet() {

    const { device } = useDevice();

    const [interfaces, setInterfaces] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadInterfaces = async () => {

        if (!device) return;

        try {

            /*
             Backend Route
             GET /olt/<ip>/ethernet
            */

            const res = await axios.get(
                `/olt/${device.ip_address}/ethernet`
            );

            if (res.data.status === "success") {

                setInterfaces(res.data.interfaces || []);

            }

        } catch (err) {

            console.error(err);

        }

        setLoading(false);

    };

    useEffect(() => {

        loadInterfaces();

    }, [device]);

    return (

        <div className="olt-page">

            <div className="page-title">

                Ethernet Interfaces

            </div>

            <table className="olt-styled-table">

                <thead>

                    <tr>

                        <th>Interface</th>
                        <th>Description</th>
                        <th>Speed</th>
                        <th>Status</th>
                        <th>RX</th>
                        <th>TX</th>
                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {

                        loading ?

                        <tr>

                            <td colSpan="7">

                                Loading...

                            </td>

                        </tr>

                        :

                        interfaces.map((eth,index)=>(

                            <tr key={index}>

                                <td>

                                    {eth.port_name}

                                </td>

                                <td>

                                    {eth.description}

                                </td>

                                <td>

                                    {eth.speed}

                                </td>

                                <td>

                                    {eth.status}

                                </td>

                                <td>

                                    {eth.rx_rate}

                                </td>

                                <td>

                                    {eth.tx_rate}

                                </td>

                                <td>

                                    <button
                                        className="btn btn-sm"
                                    >

                                        Details

                                    </button>

                                </td>

                            </tr>

                        ))

                    }

                </tbody>

            </table>

        </div>

    );

}